import {
    ChangeDetectorRef,
    Component,
    inject,
    OnDestroy,
    OnInit,
    signal,
    ViewChild,
    WritableSignal,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { UserInfoService } from 'src/app/services/user-info.service';
import { UserInfoHeader } from 'src/app/models/user-info.model';
import { DsHeaderModule, DsNavigationBarComponent, DsNavigationBarModule, DsNavigationItem } from "@bmw-ds/components";

// 1. Import environment to access the URL
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        DsHeaderModule,
        DsNavigationBarModule,
        RouterOutlet
    ],
})
export class AppComponent implements OnInit, OnDestroy {
    @ViewChild('navBar') navBar: DsNavigationBarComponent | undefined;

    isLandingPage = false;
    
    navigationItems: WritableSignal<DsNavigationItem[]> = signal([
        {
            label: 'Stock',
            icon: 'car',
            children: [
                {label: 'Stock Unit Search', routerLink: '/stock-unit-search'},
                {label: 'NaTIS Documents', routerLink: '/natis-documents'},
            ],
        },
        {
            label: 'Demo Stock',
            icon: 'car_bmw',
            children: [
                {label: 'Demo Stock Replenishment', routerLink: '/demo-stock'},
                {label: 'Open Requests', routerLink: '/demo-open-requests'},
            ],
        },
        {
            label: 'Build to Order',
            routerLink: '/build-to-order',
            icon: 'assembly',
        },
        {
            label: 'Replenishment Stock',
            icon: 'repeat',
            children: [
                {label: 'Stock Replenishment', routerLink: '/replenishment-stock'},
                {label: 'Open Requests', routerLink: '/replenishment-open-requests'},
                {label: 'Showroom Capacity', routerLink: '/showroom-capacity'},
            ],
        },
        {
            label: 'Unit Overview',
            href: environment.externalLinks.unitOverview,
            target: '_blank',
            icon: 'external_link'
        }
    ]);
    title = 'Stock Management System';

    private readonly router = inject(Router);
    private readonly userInfoService = inject(UserInfoService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                const url = this.router.url;
                this.isLandingPage = (url === '/' || url === '/landing' || url === '');
            });
    }

    get userInfoHeader(): UserInfoHeader {
        return this.userInfoService.userInfo();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    logoutFromApp() {
        this.router.navigate(['/logout']);
    }
}
